import { createAction, props } from '@ngrx/store';
import { Project } from '../../models/dbmodels';
import { ProjectSearchRequest, ProjectSearchResponse, } from '../../models/viewmodels';


export const loadAllProjectsForSearchRequest = createAction(
  '[Projects] Load All Projects For Search Request'
);

export const loadProjectsSuccess = createAction(
  '[Projects] Load Projects Success',
  props<{ projects: Project[] }>()
);

export const searchProjectsSuccess = createAction(
  '[Projects] Search Projects Success',
  props<{ request: ProjectSearchRequest; response: ProjectSearchResponse }>()
);

export const loadProjectsFailure = createAction(
  '[Projects] Load Projects Failure',
  props<{ error: Error }>()
);

export const updateProjectsSearchRequest = createAction(
  '[Projects] Update Projects Search Request',
  props<{ searchRequest: ProjectSearchRequest }>()
)

export const clearProjectsSearchRequest = createAction(
  '[Projects] Clear Projects Search Request'
)
